/**
 * Typed wrapper for /salescoach/api/inbox/*. Mirrors `briefs-api.ts`:
 * `buildApiUrl` strips defaults and resolves the preset; unwrapping the
 * envelope is the hook's job.
 */

import { apiFetch } from '@/services/api';
import { buildApiUrl } from '@/services/api-client';
import type { Filters } from '@/lib/filters-schema';
import type { ApiEnvelope, InboxKpis } from './api-types';

export async function fetchInboxKpis(
  filters: Filters,
): Promise<ApiEnvelope<InboxKpis>> {
  return apiFetch<ApiEnvelope<InboxKpis>>(
    buildApiUrl('/salescoach/api/inbox/kpis', filters),
  );
}
